import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APMultiTermsQuery } from '../../../plan/queries/ap_mm_terms_query';
import { APUserModeConfig } from './../../../global/components/user_mode_config/config/ap_user_mode_config';

class CourseTileGroupMenuController {
  private genericSlot: any;
  private isAdvisor: boolean;
  private addToTermMenuItemText = 'Add Course to Term';
  private isFromTerm: boolean | string;
  private popupMenuId: string;
  constructor(
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAPMultiTermsQuery: APMultiTermsQuery,
    private loadMmAcademicPlanCommand: ICommand,
    private saveMmCourseGroupToTermCommand: ICommand,
    private removeMmCourseFromTermCommand: ICommand,
    private removeMmCourseGroupFromTermCommand: ICommand,
    private saveMmCourseToTermCommand: ICommand
  ) {
    this.popupMenuId = _4.uniqueId();
  }

  initialize() {
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    this.isFromTerm = _4.isBoolean(this.isFromTerm) ? this.isFromTerm : this.isFromTerm === 'true';
    this.addToTermMenuItemText = this.isFromTerm ? 'Move to Term' : 'Add to Term';
  }
  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
  }
  removeFromTerm() {
    const { id, type } = this.genericSlot;
    if (_4.toLower(type) === 'course') {
      this._removeCourseFromTerm(id).then((studentId: number) => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    } else {
      this._removeCourseGroupFromTerm(id).then((studentId: number) => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    }
  }
  _removeCourseFromTerm(id: number) {
    return this.removeMmCourseFromTermCommand(id);
  }
  _removeCourseGroupFromTerm(id: number) {
    return this.removeMmCourseGroupFromTermCommand(id);
  }

  _removeCoursegroupFromTermAndAddCoursegroupToAnotherTerm(termData: any) {
    const { id: plannedCourseGroupId = 0 } = this.genericSlot;
    const payload = {
      term: _4.get(termData, 'id', 0),
      program_slot: _4.get(this.genericSlot, 'slot_id', 0),
      course_group: _4.get(this.genericSlot, 'courseGroupId', 0)
    };
    this._removeCourseGroupFromTerm(plannedCourseGroupId).then(() => {
      this.saveMmCourseGroupToTermCommand(payload).then((studentId: number) => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    });
  }
  _removeCourseFromTermAndAddCourseToAnotherTerm(term: any) {
    const plannedCourseId = _4.get(this.genericSlot, 'id', 0);
    const payload = {
      term: term.id,
      course: _4.get(this.genericSlot, 'course_id', 0),
      program_slot: _4.get(this.genericSlot, 'slot_id', 0)
    };
    this._removeCourseFromTerm(plannedCourseId).then((studentId: number) => {
      this.saveMmCourseToTermCommand(payload).then(() => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    });
  }

  moveToTerm(term: any) {
    const isFromTerm = this.isFromTerm;
    const { id: program_slot = 0, type, courseGroupId = 0, course_id: courseId = 0 } = this.genericSlot;
    const payload = {
      program_slot,
      term: term.id
    };
    if (_4.toLower(type) === 'course') {
      this._removeCourseFromTermAndAddCourseToAnotherTerm(term);
    } else {
      payload['course_group'] = courseGroupId;
      if (!isFromTerm) {
        this.saveMmCourseGroupToTermCommand(payload).then((studentId: number) => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      } else {
        this._removeCoursegroupFromTermAndAddCoursegroupToAnotherTerm(term);
      }
    }
  }
}

class CourseTileGroupMenu implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      genericSlot: '<',
      isFromTerm: '<'
    };
    this.controller = CourseTileGroupMenuController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_tile_menu/course_tile_group_menu.html';
  }
}

angular.module('capability-ng-academic-planner').component('courseTileGroupMenu', new CourseTileGroupMenu());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_tile_menu/course_tile_group_menu.ts